import styled from 'styled-components';
import { space } from '../../util/styled';

export const FormSection = styled.div`
  margin-bottom: 60px;
  ${space};
`;
export default FormSection;
